import request from '@/utils/request'

let AnchorApi = {
  /*主播列表*/
  anchorlist(data) {
    return request._post('/shop/plus.anchor.anchor/index', data);
  },

  /*主播详情*/
  toEditAnchor(data) {
    return request._get('/shop/plus.anchor.anchor/detail', data);
  },

  /*修改主播手机号码*/
  editAnchorPhone(data) {
    return request._post('/shop/plus.anchor.anchor/changePhone', data);
  },

  /*主播预告列表*/
  anchorNoticeList(data) {
    return request._post('/shop/plus.anchor.anchor/noticeList', data);
  },

   /*任务积分列表*/
  anchorCoinList(data) {
    return request._post('/shop/plus.anchor.anchor/coinList', data);
  },

  /*审核主播预告*/
  auditNotice(data) {
    return request._post('/shop/plus.anchor.anchor/auditNotice', data);
  },
  /*审核积分打卡*/
  auditCoin(data) {
    return request._post('/shop/plus.anchor.anchor/auditAnchorCoin', data);
  },
  /*赠送积分*/
  sendCoin(data) {
    return request._post('/shop/plus.anchor.anchor/sendCoin', data);
  },
}
export default AnchorApi;



// WEBPACK FOOTER //
// ./src/api/anchor.js